import { render, staticRenderFns } from "./SliceNestedPage.vue?vue&type=template&id=a2556162&lang=pug&"
import script from "./SliceNestedPage.vue?vue&type=script&lang=js&"
export * from "./SliceNestedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports